import React, { CSSProperties, FC, useEffect } from 'react';
import { useDrag, DragSourceMonitor } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { ITendersDndItem } from 'src/models/procurements/Tenders/types';
import { useDNDItem } from 'src/models/procurements/Tenders/hooks';
import { TendersTableItem } from 'src/models/procurements/TendersViews';

interface Props {
  record: TendersTableItem;
  className?: string;
  style?: CSSProperties;
  [x: string]: unknown;
}

export const ProcurementsOverviewDrag: FC<Props> = ({ record, className, style, ...restProps }: Props) => {
  const dndOverviewItem: ITendersDndItem = useDNDItem(record);
  const [{ opacity }, drag, preview] = useDrag({
    item: dndOverviewItem,

    collect: (monitor: DragSourceMonitor) => ({
      isDragging: monitor.isDragging(),
      item: monitor.getItem(),
      opacity: monitor.isDragging() ? 0.4 : 1
    })
  });

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, [preview]);

  return <tr ref={drag} className={className} style={{ cursor: 'move', opacity, ...style }} {...restProps} />;
};

const RowComponent: FC<Props> = props => {
  const { record } = props;
  if (record) {
    return <ProcurementsOverviewDrag {...props} />;
  } else {
    return <tr {...props} />;
  }
};

export default RowComponent;
